import Marquee from "react-fast-marquee";

const WORDS = [
  "Precision Craftsmanship",
  "Architectural Integrity",
  "Timeless Design",
  "Honest Building",
];

export const Ribbon = () => (
  <section
    data-testid="marquee-section"
    className="border-y border-white/10 py-10 bg-[#111110]"
  >
    <Marquee speed={30} gradient={false} autoFill>
      {WORDS.map((w, i) => (
        <div key={i} className="flex items-center">
          <span className="font-serif italic text-4xl sm:text-6xl font-light text-[#F4F3F0]/25 px-12">
            {w}
          </span>
          <span className="text-[#C05C3F] text-3xl">✦</span>
        </div>
      ))}
    </Marquee>
  </section>
);
